import { render, staticRenderFns } from "./footersPartner.vue?vue&type=template&id=03fab376&scoped=true"
import script from "./footersPartner.vue?vue&type=script&lang=js"
export * from "./footersPartner.vue?vue&type=script&lang=js"
import style0 from "./footersPartner.vue?vue&type=style&index=0&id=03fab376&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fab376",
  null
  
)

export default component.exports